import { API_ROOT } from '../../config/config'
import { doGet, doPost, doDownload, doPostFiles, doPostDownload } from './utils'

// const API_ROOT = 'http://localhost:80/api'

const API_ROOT_VER = `${API_ROOT}/v1/accounting`
const API_ROOT_VERs = `${API_ROOT}/files`

export const getAssetRegister = (projectCode, period, pageNum, pageSize) => {
  // const API_ROOT_VER = 'http://localhost:9014/api/v1/accounting'
  const url = `${API_ROOT_VER}/asset-register?projectCode=${projectCode || ''}&period=${
    period || 0
  }&pageNum=${pageNum || 0}&pageSize=${pageSize || 0}`
  return doGet(url)
}

export const getAssetRegisterById = (id) => {
  // const API_ROOT_VER = 'http://localhost:80/api/v1/accounting'
  const url = `${API_ROOT_VER}/asset-register/id?id=${id}`
  return doGet(url)
}

export const saveAssetRegister = (request, projectCode, period) => {
  // const API_ROOT_VER = 'http://localhost:80/api/v1/accounting'
  const url = `${API_ROOT_VER}/asset-register/${projectCode}/${period}`
  return doPostFiles(url, request)
}

export const saveAssetRegisterRequest = (projectCode, period, request) => {
  // const API_ROOT_VER = 'http://localhost:9014/api/v1/accounting'
  const url = `${API_ROOT_VER}/asset-register/${projectCode}/${period}/request`
  return doPost(url, request)
}

export const getAssetRegisterWaittingApprove = () => {
  const url = `${API_ROOT_VER}/asset-register/waitting-approve`
  return doGet(url)
}

export const searchAssetRegisterWaittingApprove = (request) => {
  const url = `${API_ROOT_VER}/asset-register/search-waitting-approve`
  return doPost(url, request)
}

export const getAssetRegisterWaittingApproveByRequestId = (id) => {
  const url = `${API_ROOT_VER}/asset-register/waitting-approve/register/${id}`
  return doGet(url)
}

export const createRegisterNumber = (request) => {
  const url = `${API_ROOT_VER}/asset-register/create-register-number`
  return doPost(url, request)
}

export const approveRegisterAsset = (request) => {
  const url = `${API_ROOT_VER}/asset-register/approve-register`
  return doPost(url, request)
}

export const getAssetReportPage = (projectCode) => {
  const url = `${API_ROOT_VER}/asset-report/${projectCode}`
  return doGet(url)
}

export const getAssetStatusReportPage = (projectCode) => {
  const url = `${API_ROOT_VER}/asset-status-report/${projectCode}`
  return doGet(url)
}

export const getAssetQrCodeReportPage = (projectCode, pageNumber, pageSize) => {
  const url = `${API_ROOT_VER}/asset-qr-code/${projectCode}?pageNumber=${pageNumber}&pageSize=${pageSize}`
  return doGet(url)
}

export const searchAssetQrCodeReportPage = (projectCode, request, pageNumber, pageSize) => {
  const url = `${API_ROOT_VER}/asset-qr-code/${projectCode}/search?pageNumber=${
    pageNumber || 0
  }&pageSize=${pageSize || 0}`
  return doPost(url, request)
}

export const PostDownloadAssetQrCodeReportPage = (projectCode, request) => {
  const url = `${API_ROOT_VERs}/download/accounting-asset-qr-code/${projectCode}`
  return doPostDownload(url, request)
}

export const searchAssetprojectregistration = (request) => {
  // const API_ROOT = 'http://localhost:9009/api'

  const url = `${API_ROOT}/files/preview/assetprojectregistration`
  return doPost(url, request)
}

export const exportAssetprojectregistration = (request) => {
  // const API_ROOT = 'http://localhost:9009/api'

  const url = `${API_ROOT}/files/download/assetprojectregistration`
  return doPostDownload(url, request)
}

export const searchAssetprojectstatus = (request) => {
  // const API_ROOT = 'http://localhost:9009/api'

  const url = `${API_ROOT}/files/preview/assetprojectstatus`
  return doPost(url, request)
}

export const exportAssetprojectstatus = (request) => {
  // const API_ROOT = 'http://localhost:9009/api'

  const url = `${API_ROOT}/files/download/assetprojectstatus`
  return doPostDownload(url, request)
}

//ประวัตืครุภัณฑ์
export const assetHistotry = (id) => {
  const url = `${API_ROOT_VER}/asset-history/${id}`
  return doGet(url)
}
